"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("/var/www/easy_dev/extranet/node_modules/@babel/runtime/regenerator"));

var apiSociete = _interopRequireWildcard(require("@/api/societe"));

var _vuex = require("vuex");

var CONST = _interopRequireWildcard(require("@/helpers/constantes"));

var _moment = _interopRequireDefault(require("moment"));

require("@/mixins/workflow");

var _DateDuJour = _interopRequireDefault(require("@/layout/components/DateDuJour"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

var _default = {
  name: 'Workflow',
  components: {
    DateDuJour: _DateDuJour.default
  },
  data: function data() {
    return {
      showSimulDateJour: false,
      // permet d'afficher le simulateur de la date du jiur. Utile pour les tests ou debug. A false pour déploiement en prod
      CONST: CONST,
      refresh: 0,
      currentDate: null,
      // pour tests uniquement et simuler la date du jour à partir du composant DateDuJour
      userCanDoAction: false,
      userCanValidateSynthese: false,
      paramsTrtAuto: null
    };
  },
  props: {
    affaire: Object,
    ecran: String
  },
  beforeMount: function () {
    var _beforeMount = _asyncToGenerator( /*#__PURE__*/_regenerator.default.mark(function _callee() {
      var _this = this;

      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return apiSociete.getById(this.idSociete).then(function (results) {
                if (results && results[0]) {
                  var params = results[0].gestmens_trt_params ? JSON.parse(results[0].gestmens_trt_params) : null;

                  if (params) {
                    _this.paramsTrtAuto = params;
                  }
                }
              });

            case 2:
              _context.next = 4;
              return this.getWorkflow(this.ecran).then(function () {
                _this.userCanDoAction = _this.isUserCanDoAction(_this.etape, _this.argument);
                _this.userCanValidateSynthese = _this.isUserCanValidateSynthese(_this.etape, _this.argument);
              }).then(function () {
                _this.refresh++;
              });

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function beforeMount() {
      return _beforeMount.apply(this, arguments);
    }

    return beforeMount;
  }(),
  computed: _objectSpread({}, (0, _vuex.mapGetters)(['user', 'workflow']), {
    idSociete: function idSociete() {
      return this.$store.getters.user.id_societe;
    },
    dateTrtAuto: function dateTrtAuto() {
      if (this.paramsTrtAuto && this.paramsTrtAuto.actif === 1) {
        var dayTrtAuto = this.paramsTrtAuto && this.paramsTrtAuto.day ? this.paramsTrtAuto.day : '';
        var currentDay = Number((0, _moment.default)().format('DD'));
        var monthTrtAuto = currentDay > dayTrtAuto ? (0, _moment.default)().add(1, 'months').format('MMMM') : (0, _moment.default)().format('MMMM');
        return dayTrtAuto + ' ' + monthTrtAuto;
      }

      return '- aucune date définie -';
    },
    // ===================
    // Determine la nouvelle période de gestion mensuelle pour la validation de la synthse de gestion
    dateOuvertureGestionMensuelle: function dateOuvertureGestionMensuelle() {
      // TODO: pour ne plus tenir compte du composant de simulation de la date du jour
      // 1. renseigner dt avec la date du jour: dt = moment().format('YYYYMM')
      // 2. supprimer la variable currentDate dans data () { }
      // 3. supprimer le composant dateDuJour
      var dt = this.currentDate ? (0, _moment.default)(this.currentDate, 'DD/MM/YYYY').format('YYYYMM') : (0, _moment.default)().format('YYYYMM');
      return dt;
    },
    // règles pour déverouiller le bouton "Valider la Synthèse de gestion" en fonction de la date courante
    canAskValidation: function canAskValidation() {
      // TODO: pour ne plus tenir compte du composant de simulation de la date du jour
      // 1. renseigner currentDate à partir de la date du jour: currentDate = moment().format('YYYYMM')
      // 2. supprimer la variable currentDate dans data () { }
      // 3. supprimer le composant dateDuJour
      //
      // on active le bouton "Valider la Synthèse de gestion" uniquement si: (periode gestmens + 1 mois) <= date courante <= (periode gestmen + 2mois + 7jours)
      var currentDate = this.currentDate ? (0, _moment.default)(this.currentDate, 'DD/MM/YYYY').format('YYYYMMDD') : (0, _moment.default)().format('YYYYMMDD');
      var startDate = (0, _moment.default)(this.affaire.currentGestMensYYYYMM + '01', 'YYYYMMDD').add('1', 'months').add('0', 'days').format('YYYYMMDD');
      var endDate = (0, _moment.default)(this.affaire.currentGestMensYYYYMM + '01', 'YYYYMMDD').add('2', 'months').add('7', 'days').format('YYYYMMDD');
      var isBetween = (0, _moment.default)(currentDate).isBetween(startDate, endDate, undefined, '[]'); // [] pour inclure les dates de borne dans le test
      // console.log('canAskValidation', startDate, currentDate, endDate, isBetween)

      return isBetween && this.affaire.YYYYMM === this.affaire.currentGestMensYYYYMM;
    },
    // =====================
    status: function status() {
      var stat = this.affaire.affaire.status; // cas particulier de l'écran Budget affaire si on est en gestion mensuelle
      // les controles doivent se faire comme si on etat à l'étape de budget affaire et pas de gestion mensuelle

      if (this.affaire.affaire.etape === CONST.AFFAIRE.ETAPE.GESTION_MENSUELLE.value && this.ecran === 'budget_affaire') {
        stat = this.affaire.affaire.statusBudgetAffaire;
      }

      return stat;
    },
    argument: function argument() {
      var arg = this.ecran; // cas particulier de l'écran Budget affaire si on est en gestion mensuelle
      // les controles doivent se faire comme si on etat à l'étape de budget affaire et pas de gestion mensuelle

      if (this.affaire.affaire.etape === CONST.AFFAIRE.ETAPE.GESTION_MENSUELLE.value && this.ecran === 'budget_affaire') {
        arg = 'budget_affaire';
      }

      return arg;
    },
    etape: function etape() {
      switch (this.ecran) {
        case 'affaire':
          return CONST.AFFAIRE.ETAPE.AFFAIRE.value;

        case 'vente_initiale':
          return CONST.AFFAIRE.ETAPE.VENTE_INITIALE.value;

        case 'objectifs_debourses':
          return CONST.AFFAIRE.ETAPE.OBJECTIF_DEBOURSE.value;

        case 'budget_affaire':
          return CONST.AFFAIRE.ETAPE.BUDGET_AFFAIRE.value;

        case 'gestion_mensuelle':
          return CONST.AFFAIRE.ETAPE.GESTION_MENSUELLE.value;

        default:
          return null;
      }
    },
    nextEtape: function nextEtape() {
      switch (this.ecran) {
        case 'affaire':
          return CONST.AFFAIRE.ETAPE.VENTE_INITIALE.value;

        case 'vente_initiale':
          return CONST.AFFAIRE.ETAPE.OBJECTIF_DEBOURSE.value;

        case 'objectifs_debourses':
          return CONST.AFFAIRE.ETAPE.BUDGET_AFFAIRE.value;

        case 'budget_affaire':
          return CONST.AFFAIRE.ETAPE.GESTION_MENSUELLE.value;

        case 'gestion_mensuelle':
          return CONST.AFFAIRE.ETAPE.GESTION_MENSUELLE.value;

        default:
          return null;
      }
    },
    libelleEtape: function libelleEtape() {
      switch (this.ecran) {
        case 'affaire':
          return CONST.AFFAIRE.ETAPE.AFFAIRE.title;

        case 'vente_initiale':
          return CONST.AFFAIRE.ETAPE.VENTE_INITIALE.title;

        case 'objectifs_debourses':
          return CONST.AFFAIRE.ETAPE.OBJECTIF_DEBOURSE.title;

        case 'budget_affaire':
          return CONST.AFFAIRE.ETAPE.BUDGET_AFFAIRE.title;

        case 'gestion_mensuelle':
          return CONST.AFFAIRE.ETAPE.GESTION_MENSUELLE.title;

        default:
          return '';
      }
    },
    libelleRefus: function libelleRefus() {
      switch (this.ecran) {
        case 'vente_initiale':
          return 'Refuser la validation de la vente initiale ?';

        case 'objectifs_debourses':
          return 'Refuser la validation des objectifs déboursés ?';

        case 'budget_affaire':
          return 'Refuser la validation du budget affaire ?';

        case 'gestion_mensuelle':
          return 'Refuser la validation da la gestion mensuelle ?';

        default:
          return 'Refuser la validation ?';
      }
    }
  }),
  methods: {
    // verification si l'utilisateur connecté est dans la liste des utilisateurs autorisés à faire l'action demandée
    canUserDoAction: function canUserDoAction(etape) {
      return this.canDoAction(etape); // appel de la fonction du mixin
    },
    // test s'il y a des utilisateurs destinataires de l'action demandée
    // niveau 0 = saisie
    // niveau 1 = validation de niveau 1
    // niveau 2 = validation de nvieau 2
    isUsersNiveau: function isUsersNiveau(niveau) {
      var res = false;

      switch (niveau) {
        case 0:
          res = this.users.niveau0 && this.users.niveau0.length > 0;
          break;

        case 1:
          res = this.users.niveau1 && this.users.niveau1.length > 0;
          break;

        case 2:
          res = this.users.niveau2 && this.users.niveau2.length > 0;
          break;

        default:
          res = false;
      } // console.log('ecran', this.ecran, niveau, res, this.usersNiveau0, this.usersNiveau1, this.usersNiveau2)


      return res;
    },
    // ===============================
    // =============================================
    // gestion du bouton soummettre pour validation
    // =============================================
    handleToValidate: function handleToValidate() {
      var _this2 = this;

      this.$confirm('Voulez-vous soumettre cette étape pour validation', 'Confirmation', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Annuler',
        type: 'warning'
      }).then(function () {
        var action = null;

        switch (_this2.status) {
          case CONST.AFFAIRE.STATUS.CREATED.value:
          case CONST.AFFAIRE.STATUS.DENIED1.value:
          case CONST.AFFAIRE.STATUS.DENIED2.value:
            // s'il y a un niveau de validation 1 on fait une demande de validation aux utilisateurs de niveau 1
            if (_this2.isUsersNiveau(1)) {
              action = {
                ecran: _this2.ecran,
                from: _this2.user.firstname + ' ' + _this2.user.lastname,
                actionBefore: 'handleBeforeToValidate',
                actionAfter: 'handleAfterToValidate',
                status: CONST.AFFAIRE.STATUS.TOVALIDATE1.value,
                statusBudgetAffaire: CONST.AFFAIRE.STATUS.TOVALIDATE1.value,
                etape: _this2.affaire.affaire.etape,
                niveau: 1,
                message: 'Demande de validation envoyée',
                emailTemplate: _this2.ecran + '_tovalidate'
              };
            }

            break;
          // s'il y a un niveau de validation 2, on fait une demande de validation aux utilisateurs de niveau 2

          case CONST.AFFAIRE.STATUS.TOVALIDATE1.value:
            if (_this2.isUsersNiveau(2)) {
              action = {
                ecran: _this2.ecran,
                from: _this2.user.firstname + ' ' + _this2.user.lastname,
                actionBefore: 'handleBeforeToValidate',
                actionAfter: 'handleAfterToValidate',
                status: CONST.AFFAIRE.STATUS.TOVALIDATE2.value,
                statusBudgetAffaire: CONST.AFFAIRE.STATUS.TOVALIDATE2.value,
                etape: _this2.affaire.affaire.etape,
                niveau: 2,
                message: 'Demande de validation envoyée',
                emailTemplate: _this2.ecran + '_tovalidate'
              };
            }

            break;
        }

        _this2.$emit('handleAction', action);
      });
    },
    // ==========================
    // gestion du bouton valider
    // ==========================
    handleValidate: function handleValidate(msg) {
      var _this3 = this;

      var message = typeof msg === 'string' ? msg : 'Voulez-vous accepter la demande de validation'; // cas de l'ouverture de la gestion mensuelle, on complète le message de confirmation

      if (this.nextEtape === CONST.AFFAIRE.ETAPE.GESTION_MENSUELLE.value && this.affaire.affaire.statusBudgetAffaire === 0) {
        // uniquement s'il n'y a plus de valideur
        if (this.status !== CONST.AFFAIRE.STATUS.TOVALIDATE1.value || !this.isUsersNiveau(2)) {
          var dt = (0, _moment.default)(this.dateOuvertureGestionMensuelle, 'YYYYMM').subtract(1, 'months').format('MM/YYYY'); // date à partir du Mixin

          message += ' et ouvrir la gestion mensuelle pour la période du <strong>' + dt + '</strong>';
        }
      }

      this.$confirm(message + ' ?', 'Confirmation', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Annuler',
        dangerouslyUseHTMLString: true,
        type: 'warning'
      }).then(function () {
        var action = null;

        switch (_this3.status) {
          case CONST.AFFAIRE.STATUS.TOVALIDATE1.value:
            // on valide la demande de validation 1 et on envoie une demande de validation de niveau 2
            if (_this3.isUsersNiveau(2)) {
              action = {
                ecran: _this3.ecran,
                from: _this3.user.firstname + ' ' + _this3.user.lastname,
                actionBefore: 'handleBeforeToValidate',
                actionAfter: 'handleAfterToValidate',
                status: CONST.AFFAIRE.STATUS.TOVALIDATE2.value,
                statusBudgetAffaire: CONST.AFFAIRE.STATUS.TOVALIDATE2.value,
                etape: _this3.affaire.affaire.etape,
                niveau: 2,
                message: 'Demande de validation acceptée et nouvelle attente de validation',
                emailTemplate: _this3.ecran + '_validated2'
              }; // sinon on valide la demande de validation de niveau 1 et on passe à l'étape suivante
            } else {
              action = {
                ecran: _this3.ecran,
                from: _this3.user.firstname + ' ' + _this3.user.lastname,
                actionBefore: 'handleBeforeValidated',
                actionAfter: 'handleAfterValidated',
                status: CONST.AFFAIRE.STATUS.CREATED.value,
                statusBudgetAffaire: CONST.AFFAIRE.STATUS.CREATED.value,
                etape: _this3.nextEtape,
                niveau: 0,
                message: 'Demande de validation acceptée',
                emailTemplate: _this3.ecran + '_validated'
              };
            }

            break;
          // si aucun niveau de validation 1 et 2, on valide la demande de validation et on passe à l'étape suivante

          default:
            action = {
              ecran: _this3.ecran,
              from: _this3.user.firstname + ' ' + _this3.user.lastname,
              actionBefore: 'handleBeforeValidated',
              actionAfter: 'handleAfterValidated',
              status: CONST.AFFAIRE.STATUS.CREATED.value,
              statusBudgetAffaire: CONST.AFFAIRE.STATUS.CREATED.value,
              etape: _this3.nextEtape,
              niveau: 0,
              message: 'Demande de validation acceptée',
              emailTemplate: _this3.ecran + '_validated'
            };
        }

        action.periode_gestmens = _this3.dateOuvertureGestionMensuelle;

        _this3.$emit('handleAction', action);
      });
    },
    // ===========================
    // gestion du bouton refuser
    // ===========================
    handleDeny: function handleDeny() {
      var _this4 = this;

      this.$prompt('Entrez le motif du refus', this.libelleRefus, {
        confirmButtonText: 'OK',
        cancelButtonText: 'Annuler',
        inputPattern: /^\s*\S+.*/,
        inputErrorMessage: 'Champ obligatoire',
        type: 'warning',
        inputType: 'textarea'
      }).then(function (_ref) {
        var value = _ref.value;
        var action = null;

        switch (_this4.status) {
          // si le refus concerne la demande de validation de niveau 1
          case CONST.AFFAIRE.STATUS.TOVALIDATE1.value:
            action = {
              ecran: _this4.ecran,
              from: _this4.user.firstname + ' ' + _this4.user.lastname,
              actionBefore: 'handleBeforeDeny',
              actionAfter: 'handleAfterDeny',
              status: CONST.AFFAIRE.STATUS.DENIED1.value,
              statusBudgetAffaire: CONST.AFFAIRE.STATUS.DENIED1.value,
              etape: _this4.affaire.affaire.etape,
              niveau: 0,
              motifRefus: value,
              message: 'Demande de validation refusée: ' + value,
              emailTemplate: _this4.ecran + '_denied'
            };
            break;
          // si le refus concerne la demande de validation de niveau 2

          case CONST.AFFAIRE.STATUS.TOVALIDATE2.value:
            action = {
              ecran: _this4.ecran,
              from: _this4.user.firstname + ' ' + _this4.user.lastname,
              actionBefore: 'handleBeforeDeny',
              actionAfter: 'handleAfterDeny',
              status: CONST.AFFAIRE.STATUS.DENIED2.value,
              statusBudgetAffaire: CONST.AFFAIRE.STATUS.DENIED2.value,
              etape: _this4.affaire.affaire.etape,
              niveau: '0, 1',
              // pour notifier les utilisateurs du niveau 0 et 1
              motifRefus: value,
              message: 'Demande de validation refusée: ' + value,
              emailTemplate: _this4.ecran + '_denied'
            };
            break;
        }

        _this4.$emit('handleAction', action);
      });
    },
    // =============================================
    // Gestion du bouton Valider Synthèse de gestion
    // =============================================
    handleValidateGestMens: function handleValidateGestMens() {
      /**
       * La validation manuelle de la synthèse de gestion n'est plus utilisée
       * Elle est fait maintenant automatiquement par un event mysql à chaque début de mois
       * La date de déclenchement du traitement est configurable dans l'administration et différente pour chaque société
       * Le bouton "Validation synthèse de gestion" est masqué
      */
      this.$message({
        message: 'Fonction désactivée',
        type: 'warning'
      });
      /*
      const txtPeriode = moment(this.affaire.YYYYMM, 'YYYYMM').format('MM/YYYY')
      const txtNouvellePeriode = moment(this.dateOuvertureGestionMensuelle, 'YYYYMM').format('MM/YYYY')
      this.$confirm('Voulez-vous valider synthèse de gestion du ' + txtPeriode + ' et ouvrir la nouvelle période du ' + txtNouvellePeriode + ' ?', 'Confirmation', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Annuler',
        type: 'warning'
      }).then(() => {
        const action = {
          ecran: this.ecran,
          from: this.user.firstname + ' ' + this.user.lastname,
          actionBefore: 'handleBeforeValidatedGestMens',
          actionAfter: 'handleAfterValidatedGestMens',
          status: CONST.AFFAIRE.STATUS.CREATED.value,
          statusBudgetAffaire: this.affaire.affaire.statusBudgetAffaire,
          etape: this.affaire.affaire.etape,
          niveau: 0,
          periode_gestmens: this.dateOuvertureGestionMensuelle,
          message: 'Gestion mensuelle du ' + txtPeriode + ' validée',
          data: this.dateOuvertureGestionMensuelle,
          emailTemplate: this.ecran + '_validated'
        }
        this.$emit('handleAction', action)
      })
      */
    }
  }
};
exports.default = _default;